// extracted by mini-css-extract-plugin
export var carrierTab = "_60-0";
export var carrierTabActive = "_60-1 _60-0";
export var carrierTabInactive = "_60-2 _60-0";
export var carrierTabLabel = "_60-3";
export var carrierTabLabelActive = "_60-4 _60-3";
export var carrierTabLabelInactive = "_60-5 _60-3";
export var carrierTabPercentage = "_60-6";
export var carrierTabPercentageActive = "_60-7 _60-6";
export var carrierTabPercentageInactive = "_60-8 _60-6";
export var carrierTabWinnable = "_60-9";
export var carrierTabWinnableActive = "_60-a _60-9";
export var carrierTabWinnableInactive = "_60-b _60-9";
export var comparisonContainer = "_60-d";
export var missingRateButton = "_60-n";
export var missingRateButtonActive = "_60-o _60-n";
export var missingRateButtonInactive = "_60-p _60-n";
export var missingRateButtonLabel = "_60-q";
export var missingRateButtonLabelActive = "_60-r _60-q";
export var missingRateButtonLabelInactive = "_60-s _60-q";
export var sidebar = "_60-c";
export var strategyButton = "_60-e";
export var strategyButtonActive = "_60-f _60-e";
export var strategyButtonDescription = "_60-k";
export var strategyButtonDescriptionActive = "_60-l _60-k";
export var strategyButtonDescriptionInactive = "_60-m _60-k";
export var strategyButtonInactive = "_60-g _60-e";
export var strategyButtonLabel = "_60-h";
export var strategyButtonLabelActive = "_60-i _60-h";
export var strategyButtonLabelInactive = "_60-j _60-h";
export var unitToggleButton = "_60-t";
export var unitToggleButtonActive = "_60-u _60-t";
export var unitToggleButtonInactive = "_60-v _60-t";
export var unitToggleButtonLabel = "_60-w";
export var unitToggleButtonLabelActive = "_60-x _60-w";
export var unitToggleButtonLabelInactive = "_60-y _60-w";